import { ApiResult, httpRequest, Urls } from './Shared';
import { Event } from './Property';
import { ApplessTourInfo, Prospect } from './Prospect';
import { PreferredTourFormat, TourStatuses, TourType } from '../utilities/Enums';

const MY_TOURS_URL = `${Urls.BASE_URL}/MyTours`;

export interface MyToursPageTourDto {
    tourGuid: string;
    tourStart: string;
    tourEnd: string;
    isTourNow: boolean;
    tourStatus: TourStatuses;
    tourId: number;
    hasTourStarted: boolean;
    tourType: TourType;
}

export interface MyToursPageDto {
    propertyId: number;
    propertySlug: string;
    propertyName: string;
    propertyEmail: string;
    propertyCity: string;
    propertyState: string;
    propertyStreetAddress: string;
    propertyZipCode: string;
    propertyImage: string;
    propertyLeasingUrl?: string;
    guestCardGuid: string;
    preferredTourFormat: PreferredTourFormat;
    virtualTourCompleted?: boolean;
    blockedStatus: boolean;
    tour?: MyToursPageTourDto;
}

export const getMyTours = (): Promise<ApiResult<MyToursPageDto[]>> => {
    return httpRequest<MyToursPageDto[]>(MY_TOURS_URL);
};

export const getPropsectForTour = (tourGuid: string) =>
    httpRequest<Prospect>(`${MY_TOURS_URL}/${tourGuid}/prospect`);

export const getTourDetails = (tourGuid: string) =>
    httpRequest<ApplessTourInfo>(`${MY_TOURS_URL}/${tourGuid}/appless`);

export const setSiteVisited = (tourGuid: string) =>
    httpRequest<boolean>(`${MY_TOURS_URL}/${tourGuid}/siteVisited`, 'put');

export const cancelTour = (tourGuid: string): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${MY_TOURS_URL}/${tourGuid}`, 'delete');
};

export const updateTour = (tourGuid: string, tourInfo: Event) =>
    httpRequest<Prospect>(`${MY_TOURS_URL}/${tourGuid}`, 'put', tourInfo);



// WEBPACK FOOTER //
// ./src/api/MyTours.ts